// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#0d291c","white":"#fff","container":"styles_container__ctKUp","input":"styles_input__KreGN"};